export class ProductEditMode {
    title: String;
    productId: number;
    constructor (title,productId) {
        this.title = title;
        this.productId = productId;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/rtb/info/class/product-edit-mode.ts